import isValidAnswer from '@opsbase/lib-form/helpers/isValidAnswer';
import React, { useContext } from 'react';
import DetailsOpReportAnswerCell from './DetailsOpReportAnswerCell';
import { DetailsOpReportQuestionContext } from './DetailsOpReportQuestion';
export function DetailsOpReportAnswerSPT() {
    var _a, _b;
    const { a, q, r } = useContext(DetailsOpReportQuestionContext);
    const right = false;
    // If answered
    if (isValidAnswer(a, q, r)) {
        const v = (_b = (_a = a === null || a === void 0 ? void 0 : a.text) !== null && _a !== void 0 ? _a : a.value) !== null && _b !== void 0 ? _b : '';
        return React.createElement(DetailsOpReportAnswerCell, { right: right }, v);
    }
    // Otherwise
    else {
        return React.createElement(DetailsOpReportAnswerCell, { right: right }, "- - -");
    }
}
export default DetailsOpReportAnswerSPT;
